@if (availableCabinClasses().length) {
  @if (showTriggerChips()) {
    <div class="grey-25-bg bg-primary pr-xsmall-t" data-testid="cabin-class-tags">
      <div
        class="mr-xsmall-b pr-xsmall rounded-large border white-bg surface-primary df-desktop cabin-class-title-and-chips"
        data-testid="tags-list"
      >
        <div class="font-body-1 ps-small-r font-body-medium">
          {{ 'upsellCabinClasses.chipTitle' | finLocalization }}
        </div>
        <ul class="no-list-style flex flex--wrap flex--nogrow" #tagsList>
          @for (item of availableCabinClasses(); track item.id) {
            <li class="ms-xsmall-r ms-xsmall-b">
              <fcom-chip
                [text]="'travelClass.' + item.id | finLocalization | titlecase"
                (tagClicked)="openModal($event, item.id)"
                [ngClass]="item.id"
                [attr.data-testid]="'cabin-class-tag-' + item.id"
                [theme]="isNewBrand() ? ChipTheme.LIGHT : ChipTheme.ACTIVE"
              />
            </li>
          }
        </ul>
      </div>
    </div>
  }
  <fcom-modal
    class="cabin-class-modal"
    title="{{ 'upsellCabinClasses.modalTitle' | finLocalization }}"
    [buttons]="null"
    [(open)]="cabinClassModalOpen"
  >
    <div class="relative">
      <fcom-tabs
        [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
        [nextButtonAriaLabel]="'carousel.next' | finLocalization"
        [align]="'right'"
        [layoutType]="TabLayoutType.IN_MODAL"
        class="absolute rounded-top-medium"
      >
        @for (item of availableCabinClasses(); track item.id) {
          <fcom-tab
            [title]="'travelClass.' + item.id | finLocalization | titlecase"
            [active]="item.id === selectedCabinClassId()"
            [attr.data-testid]="'cabin-class-' + item.id"
          >
            <div class="pr-medium-x">
              <fin-cms-json-content [template$]="item.template" />
            </div>
          </fcom-tab>
        }
      </fcom-tabs>
    </div>
  </fcom-modal>
}
